/* import __COLOCATED_TEMPLATE__ from './animated-typing-dots.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: { color: string };
}

const AnimatedTypingDots = templateOnlyComponent<Signature>();
export default AnimatedTypingDots;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::AnimatedTypingDots': typeof AnimatedTypingDots;
  }
}
